import { useSiteSettings } from "@/lib/siteSettings";
import Marquee from "@/components/motion/Marquee";

/** Thin ticker above the nav. Text comes from Admin > Settings > Announcement. */
export default function AnnouncementBar() {
  const s = useSiteSettings();
  const text = (s?.announcement || "").trim();
  if (!text) return null;
  const items = [text, "Pressed from copra grown on our family farms", "Every batch tested at an independent lab", "Single ingredient. Nothing added."];
  return (
    <div className="bg-brand-gold text-white font-body text-[12.5px] py-1.5" data-testid="announcement-bar">
      <Marquee items={items} />
    </div>
  );
}
